export default __webpack_public_path__ + "static/media/zoom-full.b015ffb8.png";